function WebChatRedirect(props) {
  window.location.href = props.url;
  return null;
}

export default WebChatRedirect;
